import { InformationId } from "./InformationId";
import { InformationTitle } from "./InformationTitle";
import { InformationContent } from "./InformationContent";
import { DateTime } from "../fundamental/DateTime";

const InformationType = Symbol();

export class Information {
    [InformationType]: any;
    readonly id: InformationId;
    readonly title: InformationTitle;
    readonly content: InformationContent;
    readonly createdTime: DateTime;
    readonly isRead: boolean;

    private constructor(
        id: InformationId,
        title: InformationTitle,
        content: InformationContent,
        createdTime: DateTime,
        isRead: boolean
    ) {
        this.id = id;
        this.title = title;
        this.content = content;
        this.createdTime = createdTime;
        this.isRead = isRead;       
    }

    static from(
        id: InformationId,
        title: InformationTitle,
        content: InformationContent,
        createdTime: DateTime,
        isRead: boolean
    ): Information {
        return new Information(id, title, content, createdTime, isRead);
    }
}

export type InformationJson = {
    id: string,
    title: string,
    content: string,
    createdTime: string,
    isRead: boolean
};
